import cookieModal from './cookies_panel'

cookieModal.methods.setUtmCookie('utm', 'girona', 15)
